<script>

import {appConfig} from "@/config";

export default {
  name: "AuthStatewide",
  data() {
    return {
      isProcessing: false,
      authCode: null,
    };
  },
  created() {
    console.log('!!!STW>CREATED');
    if (this.$route && this.$route.params && this.$route.params.authCode && this.$route.params.authCode != '') {
      this.authCode = this.$route.params.authCode;
    }
  },
  mounted() {
    console.log('!!!STW>MOUNTED');
    if (this.authCode && this.authCode != null && !this.isProcessing) {
      console.log('!!!STW>', this.authCode);
      this.isProcessing = true;
      this.loginByCode(this.authCode);
    }
  },
  methods: {
    auth() {
      this.$store.dispatch("auth/successLogin").then(() => {
        // let currentPath = this.$router.currentRoute.path;
        // if(currentPath==='/login') {
        if (this.$store.getters['currentUser/isUserTypeRepairer']) {
          this.$router.push('/r').then(() => {
            window.scrollTo(0, 0)
          });
        } else if (this.$store.getters['currentUser/isUserTypeSupplier']) {
          this.$router.push('/s').then(() => {
            window.scrollTo(0, 0)
          });
        }
        // }
      });
    },
    loginByCode(authCode) {
      if (authCode) {
        NProgress.start();
        this.$store.dispatch('auth/loginStatewide', {authCode})
            .then((response) => {
              this.authCode = null;
              if (response && response.data && response.data._status) {
                this.auth();
                NProgress.done();
              } else {
                NProgress.done();
              //  document.location.replace(appConfig.statewideLandingUrl + '/'); //ToDo temp
              }
            })
            .catch(() => {
              NProgress.done();
             // document.location.replace(appConfig.statewideLandingUrl + '/'); //ToDo temp
            });
      }
    },
  }
};
</script>

<template>
  <div className=""></div>
</template>


